import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { fuseAnimations } from '../../../../../@fuse/animations';
import { FuseDirectivesModule } from '../../../../../@fuse/directives/directives';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ChatStore } from '../../../../services/chat/chat-store.service';
import {
  NewConversationDialogComponent,
  NewConversationResult,
} from '../sidenavs/left/new-conversation-dialog/new-conversation-dialog.component';

@Component({
  selector: 'chat-start',
  templateUrl: './chat-start.component.html',
  styleUrls: ['./chat-start.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatButtonModule, TranslateModule, FuseDirectivesModule],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class ChatStartComponent {
  constructor(
    private store: ChatStore,
    private dialog: MatDialog,
  ) {}

  /** Même flux que le bouton + de la liste (le toggler de sidenav de la démo était mort). */
  public newConversation(): void {
    this.dialog
      .open<NewConversationDialogComponent, void, NewConversationResult>(NewConversationDialogComponent, {
        // Même right side panel que depuis la liste (mobile : footer fixe).
        panelClass: 'chat-nc-panel',
        width: '420px',
        maxWidth: '100vw',
        height: '100vh',
        position: { top: '0', right: '0' },
        autoFocus: '[cdkFocusInitial]',
      })
      .afterClosed()
      .subscribe((result) => {
        if (!result) {
          return;
        }
        if (result.type === 'direct') {
          this.store.createDirect(result.userUuid);
        } else {
          this.store.createGroup(result.name, result.userUuids);
        }
      });
  }
}
